<template>
<div>
<MainToolbar v-bind:notif="notif" v-bind:objDialog="objDialog"></MainToolbar>
<transition name="router-anim" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown">
  <v-content>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex md8 xs12>
          <v-btn v-if="IsAccessAddUser" color="green white--text" @click="addUser">Add New</v-btn>
        </v-flex>
        <v-flex md4 xs12>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-flex>
      </v-layout>
      <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
      <v-data-table v-model="selected"
          :headers="headers"
          :items="users"
          :pagination.sync="pagination"
          :search="search"
          :rows-per-page-items=[10,20,35]
          :custom-sort="customSort"
          class="elevation-1">
          <template slot="headers" slot-scope="props">
            <tr>
              <th v-for="header in props.headers"
                  :key="header.text"
                  :class="['column', header.sortable == false ? '' : 'sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.visibility]"
                  @click="header.sortable != false && changeSort(header.value)">
                  <v-icon small v-show="header.sortable != false">arrow_upward</v-icon>
                  {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.Username }}</td>
            <td class="text-xs-center">{{ props.item.FirstName }}</td>
            <td class="text-xs-center">{{ props.item.LastName }}</td>
            <td class="text-xs-center">{{ props.item.IsActive ? 'Yes' : 'No' }}</td>
            <td class="justify-center layout px-0" v-if="IsAccessEditUser || IsAccessDeleteUser">
              <v-btn v-if="IsAccessEditUser && validUser(props.item.Username, 'edit')" fab small dark color="green" class="white--text" @click="editUser(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn v-if="IsAccessDeleteUser && validUser(props.item.Username, 'delete')" fab small dark color="green" class="white--text" @click="deleteUser(props.item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">
            Sorry, nothing to display here.
          </template>
          Your search for "{{ search }}" found no results.
      </v-data-table>
      <v-progress-linear :indeterminate="true" height="5" color="green" v-if="loading"></v-progress-linear>
      <v-dialog v-model="dialog" max-width="600px">
          <v-card>
              <v-card-title primary-title style="background-color:#4caf50; color:white;">
                  <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                  <v-form ref="userForm" v-model="validateuserForm" lazy-validation>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-text-field
                            label="User Name"
                            prepend-icon="edit"
                            v-model="editedItem.Username"
                            v-if="editedItem.Username !== 'superadmin'"
                            required
                            :rules="usernameRules"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                            label="Password"
                            type="password"
                            prepend-icon="edit"
                            v-model="editedItem.Password"
                            v-if="editedItem.Username !== 'superadmin'"
                            :required="!isEdit"
                            :rules="[
                               v => (isEdit || !!v) || 'Password is required'
                            ]"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                            label="First Name"
                            prepend-icon="edit"
                            v-model="editedItem.FirstName"
                            required
                            :rules="firstNameRules"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field
                            label="Last Name"
                            prepend-icon="edit"
                            v-model="editedItem.LastName"
                            required
                            :rules="lastNameRules"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-switch v-model="editedItem.IsActive" label="Is Active" color="primary"></v-switch>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="isEdit && editedItem.Username !== 'superadmin'">
                      <v-flex xs12>
                        <AssignedInput ref="assignedInput" title="Roles" :listHeight="220" :unassignedItems="editedItem.unassignedRoles" :assignedItems="editedItem.assignedRoles"></AssignedInput>
                      </v-flex>
                    </v-layout>
                  </v-form>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                          <v-btn outline color="green darken-2" @click.native="done()" :disabled="btnDoneDisabled">Done <v-icon right dark>check_circle</v-icon></v-btn>
                          <v-btn outline color="green darken-2" @click.native="close">Cancel</v-btn>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                          <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
                      </v-flex>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</transition>
</div>
</template>
<script>
import DataService from '@/services/data-service';
import moment from 'moment';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import MainToolbar from '@/components/MainToolbar.vue';
import AssignedInput from '@/components/AssignedInput.vue';

const dataService = new DataService();

export default {
  name: 'users',
  props: [],
  components: {
    MainToolbar,
    AssignedInput,
  },
  data: () => ({
    validateuserForm: false,
    dialog: false,
    btnDoneDisabled: false,
    dialogDetails: false,
    notif: {
      color: 'success',
      message: '',
      show: false,
    },
    objDialog: {
      dialog_title: '',
      dialog_body: '',
      btn_ok_text: 'Ok',
      btn_cancel_text: 'Cancel',
      show: false,
      result: undefined,
    },
    dialogDetailsAction: null,
    loading: false,
    actioninProgress: false,
    isEdit: false,

    editedItem: {
      UserId: '',
      Username: '',
      FirstName: '',
      LastName: '',
      Password: '',
      IsActive: false,
      Roles: [],
      assignedRoles: [],
      unassignedRoles: [],
    },
    defaultItem: {
      UserId: '',
      Username: '',
      FirstName: '',
      LastName: '',
      Password: '',
      IsActive: false,
      Roles: [],
      assignedRoles: [],
      unassignedRoles: [],
    },
    search: '',
    pagination: {
      sortBy: 'Username',
    },
    selected: [],
    headers: [],
    users: [],
    roles: [],

    usernameRules: [
      v => !!v || 'User Name is required',
      v => (v && v.length <= 15) || 'User Name must be less than 15 characters',
      v => /^[a-zA-Z0-9]+$/.test(v) || 'Only alphanumeric is allowed in User Name ',
    ],
    firstNameRules: [
      v => !!v || 'First Name is required',
      v => (v && v.length <= 15) || 'First Name must be less than 15 characters',
      v => /^[a-zA-Z]+$/.test(v) || 'Only alphabet is allowed in First Name ',
    ],
    lastNameRules: [
      v => !!v || 'Last Name is required',
      v => (v && v.length <= 15) || 'Last Name must be less than 15 characters',
      v => /^[a-zA-Z]+$/.test(v) || 'Only alphabet is allowed in Last Name ',
    ],
  }),
  computed: {
    formTitle() {
      return !this.isEdit ? 'NEW USER' : 'EDIT USER';
    },
    IsAccessAddUser() {
      return this.$store.getters.IsValidCode('AH2AU0800');
    },
    IsAccessEditUser() {
      return this.$store.getters.IsValidCode('AH2EU0010');
    },
    IsAccessDeleteUser() {
      return this.$store.getters.IsValidCode('AH2DU0605');
    },
  },
  watch: {
    dialog(val) {
      if (!val) this.close();
    },
  },
  created() {
    this.getRoles();
    this.getUsers();
    this.headers = [
      {
        text: 'User Name',
        value: 'Username',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'First Name',
        value: 'FirstName',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
      {
        text: 'Last Name',
        value: 'LastName',
        align: 'left',
        width: '1%',
      },
      {
        text: 'Active',
        value: 'IsActive',
        align: 'left',
        width: '1%',
        visibility: 'hidden-xs-only',
      },
    ];
    if (this.IsAccessEditUser || this.IsAccessDeleteUser) {
      this.headers.push({
        text: 'Actions',
        align: 'left',
        width: '1%',
        sortable: false,
      });
    }
  },
  methods: {
    showNotif(obj) {
      const that = this;
      that.notif.show = true;
      that.notif.message = obj.message;
      that.notif.color = obj.color;
    },
    validUser(Username, option) {
      if (option === 'delete') return (Username !== 'superadmin' && Username !== this.$store.getters.getUsername);
      return (Username === this.$store.getters.getUsername || Username !== 'superadmin');
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        const sortA = a[index];
        const sortB = b[index];
        if (isDesc) {
          if (sortA < sortB) return 1;
          if (sortA > sortB) return -1;
          return 0;
        }
        if (sortA < sortB) return -1;
        if (sortA > sortB) return 1;
        return 0;
      });
      return items;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    dialogClick(res) {
      if (typeof this.objDialog.result === 'function') {
        this.objDialog.result(res);
      }
      this.objDialog.show = false;
    },
    addUser() {
      this.$refs.userForm.resetValidation();
      this.isEdit = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },
    editUser(item) {
      this.$refs.userForm.resetValidation();
      this.isEdit = true;
      this.editedItem = Object.assign({}, item);
      this.editedItem.assignedRoles = [];
      this.editedItem.unassignedRoles = [];
      if (this.roles && this.roles.length > 0) {
        if (this.editedItem.Roles && this.editedItem.Roles.length > 0) {
          this.editedItem.Roles.forEach((r) => {
            const newRole = Object.assign({}, r);
            newRole.displayText = r.RoleName;
            newRole.selected = false;
            this.editedItem.assignedRoles.push(newRole);
          });
          this.roles.forEach((r) => {
            if (this.editedItem.Roles.findIndex(o => o.RoleId === r.RoleId) === -1) {
              const newRole = Object.assign({}, r);
              newRole.displayText = r.RoleName;
              newRole.selected = false;
              newRole.UserId = this.editedItem.UserId;
              this.editedItem.unassignedRoles.push(newRole);
            }
          });
        } else {
          this.roles.forEach((r) => {
            const newRole = Object.assign({}, r);
            newRole.displayText = r.RoleName;
            newRole.selected = false;
            newRole.UserId = this.editedItem.UserId;
            this.editedItem.unassignedRoles.push(newRole);
          });
        }
      }
      this.dialog = true;
    },
    deleteUser(item) {
      this.editedItem = Object.assign({}, item);
      this.objDialog.dialog_title = 'Confirmation';
      this.objDialog.dialog_body = 'Do you want to delete user?';
      this.objDialog.btn_ok_text = 'Yes';
      this.objDialog.btn_cancel_text = 'No';
      this.objDialog.show = true;
      this.objDialog.result = (resDialog) => {
        if (resDialog) {
          this.actioninProgress = true;
          dataService.deleteUser(this.editedItem)
            .then(((res) => {
              this.showNotif({ color: 'success', message: 'User deleted' });
              this.getUsers()
                .then(() => {
                  this.actioninProgress = false;
                });
            }))
            .catch((error) => {
              this.actioninProgress = false;
              this.showNotif({ color: 'error', message: 'User not deleted, Something went wrong' });
            });
        }
      };
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.isEdit = false;
        this.btnDoneDisabled = false;
      }, 300);
    },
    done() {
      this.btnDoneDisabled = true;
      this.actioninProgress = true;
      if (!this.$refs.userForm.validate()) {
        this.actioninProgress = false;
        this.btnDoneDisabled = false;
        return;
      }

      if (this.editedItem.UserId) {
        this.editedItem.Roles = [];
        if (this.$refs.assignedInput) {
          const assignedRoles = this.$refs.assignedInput.assignedItemsLocal;
          if (assignedRoles && assignedRoles.length > 0) {
            assignedRoles.forEach((r) => {
              this.editedItem.Roles.push({
                UserId: this.editedItem.UserId,
                RoleName: r.RoleName,
                RoleId: r.RoleId,
              });
            });
          }
        }
        dataService.editUser(this.editedItem)
          .then(((res) => {
            this.showNotif({ color: 'success', message: 'User updated' });
            this.close();
            this.getUsers()
              .then(() => {
                this.actioninProgress = false;
              });
          }))
          .catch((error) => {
            this.actioninProgress = false;
            this.btnDoneDisabled = false;
            this.showNotif({ color: 'error', message: error });
          });
      } else {
        dataService.createUser(this.editedItem)
          .then((userId) => {
            this.showNotif({ color: 'success', message: 'User created' });
            this.close();
            this.getUsers().then(() => {
              this.actioninProgress = false;
            });
          })
          .catch((error) => {
            this.actioninProgress = false;
            this.btnDoneDisabled = false;
            this.showNotif({ color: 'error', message: error });
          });
      }
    },
    getUsers() {
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        this.loading = true;
        dataService.getUsersWithRoles().then((_users) => {
          const total = _users.length;
          this.loading = false;
          if (this.editedItem) {
            if (this.editedItem.UserId) {
              const newEditUser=_users.filter(f => f.UserId===this.editedItem.UserId)[0];
              this.editedItem=newEditUser||Object.assign({}, this.defaultItem);
              if (newEditUser) {
                this.isEdit = false;
              }
            }
          }
          if (this.pagination.sortBy) {
            // eslint-disable-next-line
            _users = _users.sort((a, b) => {
              const sortA = a[sortBy];
              const sortB = b[sortBy];

              if (descending) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              }
              if (sortA < sortB) return -1;
              if (sortA > sortB) return 1;
              return 0;
            });
          }
          this.users = _users;
          setTimeout(() => {
            this.loading = false;
            resolve({
              _users,
              total,
            });
          }, 1000);
        });
      });
    },
    getRoles() {
      dataService.getRoles()
        .then((_roles) => {
          this.roles = _roles;
        });
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 2px;
  padding-bottom: 2px;
}
.cell-font-size {
  font-size: 12px;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>
